import React, { useEffect, useState } from "react";
import PointStateMentBanner from "../assets/images/pointStatement.png";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import ProfileService from "../services/Profile";
import { ArrowRight } from "react-feather";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import DatePicker from "../component/DatePicker";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import { useSelector } from "react-redux";
import { formatNumberWithCommas } from "../constants/commonFunction";
import useScrollToTop from "../hooks/useScrollToTop";

const MyPointStatement = () => {
  useScrollToTop()
  const tokens = useSelector((state) => state.userTypeSlice.token);
  //Current Year
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();
  const [isPointStatementData, setIsPointStatementData] = useState("");
  const [loading, setLoading] = useState(true);
  const [isFromDate, setIsFormDate] = useState("");
  const [isToDate, setIsToDate] = useState("");
  const [checkedOption, setCheckedOption] = useState(false);
  const [checkedOptionLastThreeMonths, setCheckedOptionLastThreeMonths] =
    useState(false);
  const [checkedOptionLastSixMonths, setCheckedOptionLastSixMonths] =
    useState(false);
  const [checkedOptionLastFinancialYear, setCheckedOptionLastFinancialYear] =
    useState(false);

  const MyPointsDataFetch = async (from = "", to = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      const MyPointsResponse = await ProfileService.getAvailablePointsNew(
        from,
        to
      );

      setLoading(false);
      if (MyPointsResponse.success == true) {
        setIsPointStatementData(MyPointsResponse.response.pointDetails);
      }
    } catch (error) {
      console.error("MyPointsResponse");
      setLoading(false);
    }
  };
  //For Data Show
  useEffect(() => {
    MyPointsDataFetch();
  }, [tokens]);
  const navigate = useNavigate();
  const handlePointsEarned = () => {
    navigate(`/point-earned`);
  };
  const handleRedeemablePoints = () => {
    navigate(`/reedamable-all-point`);
  };
  const handlePointsSpent = () => {
    navigate(`/point-spent`);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    let dd = date.getDate();
    let mm = parseInt(date.getMonth());
    let yyyy = date.getFullYear();
    mm++;
    mm += "";
    dd += "";
    if (mm.length < 2) mm = "0" + mm;
    if (dd.length < 2) dd = "0" + dd;

    return `${yyyy}-${mm}-${dd}`;
  };

  const handleThirtyDaysSelect = () => {
    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    setIsFormDate(formatDate(priorDate));
    setIsToDate(formatDate(today));
    setCheckedOption(true);
    setCheckedOptionLastSixMonths(false);
    setCheckedOptionLastFinancialYear(false);
    setCheckedOptionLastThreeMonths(false);
  };
  const handleThreeMonthsSelect = () => {
    var today = new Date();
    var priorDate = new Date(new Date().setMonth(today.getMonth() - 3)); // Subtract 3 months from the current date
    setIsFormDate(formatDate(priorDate));
    setIsToDate(formatDate(today));
    setCheckedOptionLastThreeMonths(true);
    setCheckedOption(false);
    setCheckedOptionLastSixMonths(false);
    setCheckedOptionLastFinancialYear(false);
  };
  const handleSixMonthsSelect = () => {
    var today = new Date();
    var priorDate = new Date(new Date().setMonth(today.getMonth() - 6)); // Subtract 3 months from the current date
    setIsFormDate(formatDate(priorDate));
    setIsToDate(formatDate(today));
    setCheckedOptionLastSixMonths(true);
    setCheckedOptionLastFinancialYear(false);
    setCheckedOptionLastThreeMonths(false);
    setCheckedOption(false);
  };
  const handleLastFinancialYearSelect = () => {
    var today = new Date();
    var currentYear = today.getFullYear();
    var startYear = currentYear - 1; // Previous year
    var startDate = new Date(startYear, 3 - 1, 1); // April 1st of previous year
    var endDate = new Date(currentYear, 3 - 1, 0); // March 31st of current year

    setIsFormDate(formatDate(startDate));
    setIsToDate(formatDate(endDate));
    setCheckedOptionLastFinancialYear(true);
    setCheckedOptionLastThreeMonths(false);
    setCheckedOption(false);
    setCheckedOptionLastSixMonths(false);
  };
  //For Filter
  const handleFilterData = () => {
    MyPointsDataFetch(isFromDate, isToDate);
  };
  //For Reset
  const handleResetData = () => {
    setIsFormDate("");
    setIsToDate("");
    setCheckedOption(false);
    setCheckedOptionLastThreeMonths(false);
    setCheckedOptionLastSixMonths(false);
    setCheckedOptionLastFinancialYear(false);
  };
  //From Date
  const handleFormChange = (e) => {
    setIsFormDate(e.target.value);
    setCheckedOption(false);
    setCheckedOptionLastThreeMonths(false);
    setCheckedOptionLastSixMonths(false);
    setCheckedOptionLastFinancialYear(false);
  };
  //To date
  const handleToDate = (e) => {
    setIsToDate(e.target.value);
    setCheckedOption(false);
    setCheckedOptionLastThreeMonths(false);
    setCheckedOptionLastSixMonths(false);
    setCheckedOptionLastFinancialYear(false);
  };
  return (
    <>
      {loading && <Loader />}
      <BreadCrumbSecttion
        pageTitle="My Points Statement"
        currentPageName="My Points Statement"
      />
      <div className="searchBox cont-body-bg">
        <Container>
          <div className="cont-body">
            {/* <Row>
        <Col xs={12}>
            <h2>Choose Date Range</h2>
          </Col>

          
          <div className="col-lg-12">
            <div className="search-filter">
              <div className="row">
              <Col xs ={12} lg = {12}>
            <div className="d-flex choose-date-range form-group">
            <div className="form-control"><input type="radio" name="dateRange" onClick ={handleThirtyDaysSelect} checked ={checkedOption}/> <label>Last 30 days</label></div>
            <div className="form-control"><input type="radio" name="dateRange" onClick ={handleThreeMonthsSelect} checked ={checkedOptionLastThreeMonths}/> <label>Last 3 months</label></div>
            <div className="form-control"><input type="radio" name="dateRange" onClick={handleSixMonthsSelect} checked ={checkedOptionLastSixMonths}/> <label>Last 6 months</label></div>
            <div className="form-control"><input type="radio" name="dateRange" onClick={handleLastFinancialYearSelect} checked={checkedOptionLastFinancialYear}/> <label>Last Financial Year</label></div>
            </div>
            </Col>
          
          <Col xs={12} lg ={3}>
            <div className="form-group">
          <DatePicker inputFieldLabel="Form Date" 
            value={isFromDate}
            onChange={handleFormChange}/>
            </div>
          </Col>
          <Col xs={12} lg ={3}>
          <div className="form-group">
          <DatePicker inputFieldLabel="To Date"
            value={isToDate}
            onChange={handleToDate}/>
            </div>
          </Col>
          <Col xs={12} lg ={3}><PrimaryOutLineButton outlinebuttonText="Reset" className="mt-4" onClick={handleResetData}/></Col>
          <Col xs={12} lg ={3}><PrimaryGradientButton buttonText="Filter" className="mt-4" onClick={handleFilterData}/></Col>
           </div>
            </div>
          </div>
        </Row> */}

            <div className="pt-15">
              <h4 className="gradient-text">Points Statement- Year {currentYear} </h4>
              <div className="">
                <div className="loginFromsBlock  ">
                  <div className="rightLoginForm">
                    <div className="row">
                      <div className="col-lg-4">
                        <div
                          className="alert alert-primary points-statement points-bg-1"
                          role="alert"
                          onClick={handleRedeemablePoints}
                        >
                          <p>Redeemable points :</p>
                          <h2>
                            {formatNumberWithCommas(
                              isPointStatementData.opening_balance
                            )}
                          </h2>
                          <ArrowRight />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div
                          className="alert alert-primary points-statement points-bg-3"
                          role="alert"
                          onClick={handlePointsSpent}
                        >
                          <p>Points spent: </p>
                          <h2>
                            {formatNumberWithCommas(
                              isPointStatementData.points_reedemed
                            )}
                          </h2>

                          <ArrowRight />
                        </div>
                      </div>

                      
                      <div className="col-lg-4">
                        <div
                          className="alert alert-primary points-statement points-bg-2"
                          role="alert"
                          onClick={handlePointsEarned}
                        >
                          <p>Points earned in {currentYear} :</p>
                          <h2>
                            {formatNumberWithCommas(
                              isPointStatementData.points_CFY
                            )}
                          </h2>

                          <ArrowRight />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default MyPointStatement;
